module.exports = __webpack_public_path__ + "img/icn-lc-checked.6132a79b.png";